import { createReducer } from "redux-create-reducer";
import {
  CLEAR_SCORING_DECISION_TEMPLATE,
  GET_SCORING_DECISION_TEMPLATE,
} from "../types";

const initialState = {
  scoringDecisionTemplate: [],
  localizationKeys: [],
  isLoading: false,
};

const getScoringDecisionTemplateReducer = createReducer(initialState, {
  [GET_SCORING_DECISION_TEMPLATE.DEFAULT]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_DECISION_TEMPLATE.PENDING]: (state) => ({
    ...state,
    isLoading: true,
  }),
  [GET_SCORING_DECISION_TEMPLATE.REJECTED]: (state) => ({
    ...state,
    isLoading: false,
  }),
  [GET_SCORING_DECISION_TEMPLATE.FULFILLED]: (state, { payload }) => {
    return {
      ...state,
      scoringDecisionTemplate: [...payload.data],
      isLoading: false,
    };
  },
  [CLEAR_SCORING_DECISION_TEMPLATE]: () => {
    return { ...initialState };
  },
});

export default getScoringDecisionTemplateReducer;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/reducers/scoringDecisionTemplateReducer.js